import { render, staticRenderFns } from "./beaker.vue?vue&type=template&id=31c0c81d&"
import script from "./beaker.vue?vue&type=script&lang=js&"
export * from "./beaker.vue?vue&type=script&lang=js&"
import style0 from "./beaker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports